import * as R from "ramda";

import {
  inlineHTMLToJSON,
  inlineJSONToHTML,
} from "../convert";

import {
  deepFindByUID,
  deepFindOldestNotSectionAncestorByUID,
  deepFindSiblingBeforeByUID,
  deleteNodeByUID,
  generateNode,
  replaceNodeByUID,
  insertBeforeNodeByUID,
  modifyNodeValueByUIDAndKey,
  setNodeValueByUIDAndKey,
  siblingCountByUID,
  siblingIndexByUID,
} from "../doc_helpers";

import {
  replaceText,
} from "../inline_json";

export function handleDelete<DocContent extends PossibleContent>(
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentlyEditing: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  modifyContent((json, currentlyEditing) => {
    const currentSelection = currentlyEditingOverride || currentlyEditing;
    if (!currentSelection) { return json; }

    const currentlyEditingNode = deepFindByUID(json, currentSelection.uid);
    if (!currentlyEditingNode) { return json; }

    if (currentSelection.range) {
      if (currentSelection.range.start != currentSelection.range.end) {
        setCurrentlyEditing({...currentSelection, range: {start: currentSelection.range.start, end: currentSelection.range.start}});

        return modifyNodeValueByUIDAndKey(json, currentSelection.uid, currentSelection.key, (inlineHTML: InlineHtmlContent) => {
          return inlineJSONToHTML(replaceText(inlineHTMLToJSON(inlineHTML), currentSelection.range, ""));
        });
      } else if (currentSelection.range.start > 0) {
        setCurrentlyEditing({...currentSelection, range: {start: currentSelection.range.start-1, end: currentSelection.range.start-1}});

        return modifyNodeValueByUIDAndKey(json, currentSelection.uid, currentSelection.key, (inlineHTML: InlineHtmlContent) => {
          return inlineJSONToHTML(replaceText(inlineHTMLToJSON(inlineHTML), {start: currentSelection.range.start-1, end: currentSelection.range.start}, ""));
        });
      } else {
        switch (currentlyEditingNode.type) {
          case "listItem":
            if (siblingIndexByUID(json, currentlyEditingNode.uid) === 0) {
              const newParagraph = generateNode("paragraph", {content: currentlyEditingNode.content});

              let returnJSON = json;

              const parentNode = deepFindOldestNotSectionAncestorByUID(json, currentlyEditingNode.uid);

              if (!parentNode) { return json; } // TODO: ADD ERROR TO

              if (siblingCountByUID(json, currentlyEditingNode.uid) === 1) {
                returnJSON = replaceNodeByUID(returnJSON, parentNode.uid, newParagraph);
              } else {
                returnJSON = insertBeforeNodeByUID(returnJSON, parentNode.uid, newParagraph);
                returnJSON = deleteNodeByUID(returnJSON, currentlyEditingNode.uid);
              }

              setCurrentlyEditing({uid: newParagraph.uid, range: {start: 0, end: 0}, key: "content"});

              return returnJSON;
            } else {
              let returnJSON = json;

              const siblingBefore = deepFindSiblingBeforeByUID(json, currentlyEditingNode.uid);

              if (!siblingBefore) { return json; } // TODO: ADD ERROR TO

              if (!("content" in siblingBefore)) { return json; } // TODO: SHOULD THIS BLOCKED OR HANDLED A DIFFERENT WAY BE ALLOWED

              returnJSON = setNodeValueByUIDAndKey(returnJSON, siblingBefore.uid, "content", siblingBefore.content + currentlyEditingNode.content);
              returnJSON = deleteNodeByUID(returnJSON, currentlyEditingNode.uid);

              const newSelectionIndex = inlineHTMLToJSON(siblingBefore.content as string).text.length; // TODO: REMOVE AS String

              setCurrentlyEditing({uid: siblingBefore.uid, range: {start: newSelectionIndex, end: newSelectionIndex}, key: "content"});

              return returnJSON;
            }
          case "paragraph":
            const siblingBefore = deepFindSiblingBeforeByUID(json, currentlyEditingNode.uid);
            let newSelectionIndex;

            if (siblingBefore) {
              let returnJSON = json;

              switch (siblingBefore.type) {
                case "paragraph":
                  returnJSON = setNodeValueByUIDAndKey(returnJSON, siblingBefore.uid, "content", siblingBefore.content + currentlyEditingNode.content);
                  returnJSON = deleteNodeByUID(returnJSON, currentlyEditingNode.uid);

                  newSelectionIndex = inlineHTMLToJSON(siblingBefore.content).text.length;
                  setCurrentlyEditing({uid: siblingBefore.uid, range: {start: newSelectionIndex, end: newSelectionIndex}, key: "content"});

                  return returnJSON;
                case "regularList":
                case "numberedList":
                  const listItemBefore = R.last(siblingBefore.content);

                  if (!listItemBefore) { return json; } // TODO: ADD ERROR TO

                  returnJSON = setNodeValueByUIDAndKey(returnJSON, listItemBefore.uid, "content", listItemBefore.content + currentlyEditingNode.content);
                  returnJSON = deleteNodeByUID(returnJSON, currentlyEditingNode.uid);

                  newSelectionIndex = inlineHTMLToJSON(listItemBefore.content).text.length;
                  setCurrentlyEditing({uid: listItemBefore.uid, range: {start: newSelectionIndex, end: newSelectionIndex}, key: "content"});

                  return returnJSON;
                default:
                  if (currentlyEditingNode.content.length === 0) {
                    setCurrentlyEditing(undefined);

                    return deleteNodeByUID(json, currentlyEditingNode.uid);
                  } else {
                    return json; // TODO: CHECK IF OK
                  }
              }
            } else {
              if (currentlyEditingNode.content.length === 0) {
                setCurrentlyEditing(undefined);

                return deleteNodeByUID(json, currentlyEditingNode.uid);
              } else {
                return json; // TODO: CHECK IF OK
              }
            }
          default:
            return json; // TODO: CHECK IF OK
        }
      }
    }
  });
}

function countIndiciesUntilNextSpaceAndThenAChar(string: string, isDelete: boolean) {
  let array;
  if (isDelete) {
    array = string.split("");
  } else {
    array = string.split("").reverse();
  }

  let index = 0;
  let isPastACharacter = false;

  array.every ( (e) => {
    if (e !== " ") {
      isPastACharacter = true;
    }

    if (e === " " && isPastACharacter) {
      return false;
    }

    index += 1;

    return true;
  });

  return index;
}
